'use strict';

var MailTemplateCtrl = function($scope, $state, $stateParams, gettextCatalog) {
  this.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
  this._state = $state;
  this.templates = [
    {
      id: 'acceptBooking',
      name: gettextCatalog.getString('Accept Booking'),
    },
    {
      id: 'declineBooking',
      name: gettextCatalog.getString('Decline Booking'),
    },
    {
      id: 'remindAppointment',
      name: gettextCatalog.getString('Appointment Reminder'),
    },
    {
      id: 'appointmentChanged',
      name: gettextCatalog.getString('Appointment Changed'),
    },
    {
      id: 'appointmentDeleted',
      name: gettextCatalog.getString('Appointment Removed'),
    },
  ];
  this.currentTemplate = $stateParams.templateName || 'acceptBooking';
  this.open(this.currentTemplate);
};

MailTemplateCtrl.prototype.templateChanged = function() {
  this.open(this.currentTemplate);
};

MailTemplateCtrl.prototype.open = function(templateId) {
  if (templateId) {
    this._state.go('private.main.mailTemplate.detail', { templateName: templateId });
  }
};

module.exports = MailTemplateCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/mailTemplate/MailTemplateCtrl.js